import { getNextSeriesBook } from "../getNextBookForSeriesContract.js";
import { resolveBookClubDelivery, resolveBookSubscriptionDelivery, resolveSeriesDelivery, } from "./resolveDelivery.js";
export const resolveDelivery = ({ kind, product, contract, usage, ...rest }) => {
    switch (kind) {
        case "series":
            return resolveSeriesDelivery({
                nextBook: getNextSeriesBook(product.plan, usage, contract, product.campaignBooks, product.series?.products),
                renewAt: rest.renewAt,
                periodsToSkip: rest.periodsToSkip,
            });
        case "bookClub":
            return resolveBookClubDelivery({
                ...rest,
                dispatches: product.dispatches,
            });
        case "bookSubscription":
            return resolveBookSubscriptionDelivery({
                dispatches: product.dispatches,
                periodsToSkip: rest.periodsToSkip,
                isWithoutCreatedOrders: rest.isWithoutCreatedOrders,
                now: rest.now,
            });
        case "digitalService":
            return { kind: "digitalService" };
    }
};
/**
 * Flat delivery fields kept for consumers not yet migrated to `delivery`.
 * @deprecated Narrow on `delivery.kind` instead.
 */
export const getLegacyDeliveryFields = (delivery) => {
    switch (delivery.kind) {
        case "series":
            return {
                nextDispatch: undefined,
                nextBook: delivery.nextBook,
                nextDispatchProducts: undefined,
                skipBookDeadline: delivery.skipBookDeadline,
            };
        case "bookSubscription":
            return {
                nextDispatch: delivery.nextDispatch,
                nextBook: delivery.nextBook,
                nextDispatchProducts: delivery.nextDispatch?.products,
                skipBookDeadline: delivery.skipBookDeadline,
            };
        case "bookClub":
            return {
                nextDispatch: delivery.nextDispatch,
                nextBook: undefined,
                nextDispatchProducts: delivery.dispatchProducts,
                skipBookDeadline: delivery.skipBookDeadline,
            };
        case "digitalService":
            return {
                nextDispatch: undefined,
                nextBook: undefined,
                nextDispatchProducts: undefined,
                skipBookDeadline: undefined,
            };
    }
};
